<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="1200px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t("Edit Purchase's information") }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap justify-end>
            <v-flex shrink>
              <v-chip v-if="fileSelected" :selected="fileSelected" @input="removeFile()" close dark color="primary">
                <v-avatar>
                  <v-icon>insert_drive_file</v-icon>
                </v-avatar>
                <a
                  v-if="updateForm.attachment !== null"
                  :href="`${baseUrls.images}/${updateForm.attachment}`"
                  target="_blank"
                  style="color: white; text-decoration: none"
                >
                  {{ $t('Click to View Attachment') }}
                </a>
                <span v-else>{{ fileName | truncate }}</span>
              </v-chip>
              <v-btn :disabled="fileSelected" @click="chooseFile" color="primary" class="white--text">
                <v-icon left dark>attach_file</v-icon>
                {{ $t('Attach file') }}
              </v-btn>
              <input
                type="file"
                name="file"
                ref="fileInput"
                style="visibility:hidden; width:0; position:absolute; top:-9999px"
                @input="onSelectFile"
              />
            </v-flex>
          </v-layout>

          <v-layout row wrap justify-content-end>
            <v-flex xs3 pa-2>
              <v-text-field
                v-model="updateForm.supplier_invoice_number"
                :label="`${$t('Supplier Invoice Number')} *`"
                name="supplier_invoice_number"
                hide-details
                box
                background-color="white"
                :error="errors.has('supplier_invoice_number')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex pa-2>
              <v-autocomplete
                v-model="updateForm.vender_id_fk"
                :label="`${$t('Supplier')} *`"
                hide-details
                :items="supplierList"
                box
                data-vv-name="Supplier"
                background-color="white"
                :error="errors.has('Supplier')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex pt-2 v-if="hasPermissions(['vender_store'])" shrink>
              <v-tooltip top>
                <v-btn label @click="$emit('add-supplier')" slot="activator" icon fab small color="green">
                  <v-icon color="white" size="25">add</v-icon>
                </v-btn>
                <span>{{ $t('Add new supplier') }}</span>
              </v-tooltip>
            </v-flex>

            <v-flex xs2 pa-2>
              <v-menu v-model="billDateMenu" full-width max-width="290" :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  :value="updateForm.bill_date"
                  :label="`${$t('Bill Date')} *`"
                  prepend-inner-icon="event"
                  box
                  readonly
                  hide-details
                  name="bill_date"
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('bill_date')"
                  v-validate="'required|date_format:yyyy-MM-dd'"
                />
                <v-date-picker @change="billDateMenu = false" v-model="updateForm.bill_date" />
              </v-menu>
            </v-flex>

            <v-flex xs2 pa-2>
              <v-autocomplete
                v-model="updateForm.cash_or_opening_balance"
                :label="`${$t('Payment Type')} *`"
                hide-details
                :items="paymentTypes"
                box
                readonly
                data-vv-name="cash_or_opening_balance"
                background-color="white"
                :error="errors.has('cash_or_opening_balance')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs12 style="margin-top: 20px" pb-3>
              <v-layout row wrap class="form-table-header">
                <v-flex row class="form-table-content" :class="{ xs2: bothOfThem }">
                  <v-layout row wrap>
                    <v-flex xs2 pa-2 class="form-table-content">#</v-flex>
                    <v-flex xs8 pa-2 class="form-table-content">{{ $t('Product') }}</v-flex>

                    <v-flex
                      xs2
                      v-if="hasPermissions(['products_store'])"
                      style="padding-top: 3px"
                      class="form-table-content"
                    >
                      <v-tooltip top>
                        <v-btn label @click="$emit('add-product')" slot="activator" icon small color="green">
                          <v-icon color="white">add</v-icon>
                        </v-btn>
                        <span>{{ $t('Add new product') }}</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  class="form-table-content"
                  xs6
                  :class="{ xs7: hasExpiry || hasTax || hasCollection, xs8: twoOfThem, xs9: bothOfThem }"
                >
                  <v-layout row>
                    <v-flex v-if="hasCollection" pa-2 class="form-table-content" :class="{ xs3: hasTax && !hasExpiry }">
                      {{ $t('Collections') }}
                    </v-flex>
                    <v-flex pa-2 v-if="hasExpiry" class="form-table-content">{{ $t('Expiration') }}</v-flex>
                    <v-flex :class="{ xs2: hasExpiry && hasTax && !hasCollection }" pa-2 class="form-table-content">{{
                      $t('Quantity')
                    }}</v-flex>
                    <v-flex :class="{ xs2: hasExpiry && hasTax && !hasCollection }" pa-2 class="form-table-content">{{
                      `${$t('Price')}`
                    }}</v-flex>
                    <v-flex :class="{ xs2: hasExpiry && hasTax && !hasCollection }" pa-2 class="form-table-content">{{
                      `${$t('Total')} (${systemCurrency})`
                    }}</v-flex>
                    <v-flex
                      :class="{ xs2: hasExpiry && hasTax && !hasCollection }"
                      pa-2
                      v-if="hasTax"
                      class="form-table-content"
                      >{{ $t('Tax') }}</v-flex
                    >
                    <v-flex
                      :class="{ xs2: hasExpiry && hasTax && !hasCollection }"
                      pa-2
                      v-if="hasTax"
                      class="form-table-content"
                      >{{ $t('Total Tax') }}</v-flex
                    >
                  </v-layout>
                </v-flex>
                <v-flex xs1 style="padding-top: 3px" class="form-table-content">
                  <v-tooltip top>
                    <v-btn label @click="addRow()" small slot="activator" icon color="green">
                      <v-icon color="white">add</v-icon>
                    </v-btn>
                    <span>{{ $t('Add new row') }}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>

              <template v-if="rowNumbers > 0">
                <v-layout row wrap v-for="(row, index) in rowNumbers" :key="index">
                  <v-flex row pa-1 :class="{ xs2: bothOfThem }">
                    <v-layout row wrap>
                      <v-flex xs2 pa-1 style="text-align: center; margin-top: 20px; font-size: 16px">{{
                        index + 1
                      }}</v-flex>

                      <v-flex xs10>
                        <v-autocomplete
                          v-model="updateForm.product_id_fk[index]"
                          :label="`${$t('Product')} *`"
                          :items="purchaseProductsList"
                          hide-details
                          box
                          :data-vv-name="'Product' + (index + 1)"
                          background-color="white"
                          :error="errors.has('Product' + (index + 1))"
                          v-validate="'required'"
                          @input="findCollections(index)"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 :class="{ xs7: hasExpiry || hasTax || hasCollection, xs8: twoOfThem, xs9: bothOfThem }">
                    <v-layout row>
                      <v-flex
                        pa-1
                        v-if="hasCollection"
                        :class="{ xs3: hasTax && !hasExpiry, grow: hasTax && !hasExpiry }"
                      >
                        <v-autocomplete
                          v-model="updateForm.collection_id_fk[index]"
                          :label="$t('Collections')"
                          :items="collections[index]"
                          item-text="collection_name"
                          item-value="collection_id"
                          hide-details
                          box
                          :disabled="collections[index] && collections[index].length === 0"
                          :data-vv-name="'Collections' + (index + 1)"
                          background-color="white"
                          :error="errors.has('Collections' + (index + 1))"
                        />
                      </v-flex>
                      <v-flex pa-1 v-if="hasExpiry">
                        <v-menu
                          v-model="expireDateMenu[index]"
                          full-width
                          max-width="290"
                          :close-on-content-click="false"
                        >
                          <v-text-field
                            slot="activator"
                            :value="updateForm.expire_date[index]"
                            :label="`${$t('Expiration Date')}`"
                            prepend-inner-icon="event"
                            box
                            readonly
                            hide-details
                            name="expire_date"
                            background-color="white"
                            autocomplete="off"
                            :error="errors.has('expire_date' + (index + 1))"
                            v-validate="'date_format:yyyy-MM-dd'"
                          />
                          <v-date-picker
                            @change="expireDateMenu[index] = false"
                            v-model="updateForm.expire_date[index]"
                          />
                        </v-menu>
                      </v-flex>
                      <v-flex pa-1>
                        <v-text-field
                          v-model.number="updateForm.purchase_quantity[index]"
                          :label="`${$t('Quantity')} *`"
                          hide-details
                          box
                          :data-vv-name="'Quantity' + (index + 1)"
                          background-color="white"
                          :error="errors.has('Quantity' + (index + 1))"
                          v-validate="'required|decimal:3|min_value:0'"
                          @input="calculateTotal(index), calculateTotalTax(index)"
                          data-vv-delay="1000"
                        />
                      </v-flex>
                      <v-flex pa-1>
                        <v-text-field
                          v-model.number="updateForm.purchase_price[index]"
                          :label="`${$t('Price')} *`"
                          hide-details
                          box
                          :data-vv-name="'Price' + (index + 1)"
                          background-color="white"
                          :error="errors.has('Price' + (index + 1))"
                          v-validate="'required|decimal:3|min_value:0'"
                          @input="calculateTotal(index)"
                          data-vv-delay="1000"
                        />
                      </v-flex>
                      <v-flex pa-1>
                        <v-text-field
                          v-model.number="updateForm.total[index]"
                          :label="`${$t('Total')} *`"
                          hide-details
                          box
                          readonly
                          :data-vv-name="'Total' + (index + 1)"
                          background-color="white"
                          :error="errors.has('Total' + (index + 1))"
                          v-validate="'required|decimal:3'"
                          data-vv-delay="1000"
                        />
                      </v-flex>
                      <v-flex pa-1 v-if="hasTax">
                        <v-text-field
                          v-model.number="updateForm.purchase_tax[index]"
                          :label="`${$t('Tax')}`"
                          hide-details
                          box
                          :data-vv-name="'Tax' + (index + 1)"
                          background-color="white"
                          :error="errors.has('Tax' + (index + 1))"
                          v-validate="'decimal:3|min_value:0'"
                          @input="calculateTotalTax(index)"
                          data-vv-delay="1000"
                        />
                      </v-flex>
                      <v-flex pa-1 v-if="hasTax">
                        <v-text-field
                          v-model.number="updateForm.total_tax[index]"
                          :label="`${$t('Total Tax')}`"
                          hide-details
                          box
                          readonly
                          :data-vv-name="'Total Tax' + (index + 1)"
                          background-color="white"
                          :error="errors.has('Total Tax' + (index + 1))"
                          v-validate="'decimal:3|min_value:0'"
                          data-vv-delay="1000"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex
                    xs1
                    :class="index + 1 === rowNumbers && index + 1 > 1 ? 'pt-3' : 'pa-3'"
                    style="text-align: center"
                  >
                    <v-tooltip top>
                      <v-btn label flat @click="removeRow(index)" small slot="activator" icon color="error">
                        <v-icon>delete</v-icon>
                      </v-btn>
                      <span>{{ $t('Remove this row') }}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="index + 1 === rowNumbers && index + 1 > 1">
                      <v-btn label @click="addRow()" small slot="activator" icon flat>
                        <v-icon size="28" color="green">add_circle</v-icon>
                      </v-btn>
                      <span>{{ $t('Add new row') }}</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </template>
            </v-flex>

            <v-flex pa-2>
              <v-text-field
                v-model="updateForm.total_amount"
                :label="`${$t('Total Amount')} (${systemCurrency}) *`"
                hide-details
                box
                readonly
                name="total_amount"
                background-color="white"
                :error="errors.has('total_amount')"
                v-validate="'required|decimal:3'"
                data-vv-delay="1000"
              />
            </v-flex>

            <v-flex pa-2>
              <v-text-field
                v-model="updateForm.transport_cost"
                :label="`${$t('Transport Cost')} (${systemCurrency})`"
                hide-details
                box
                name="transfer_cost"
                background-color="white"
                :error="errors.has('transfer_cost')"
                v-validate="'decimal:3'"
                @input="calculateGrandTotalAmount()"
                data-vv-delay="1000"
              />
            </v-flex>

            <v-flex pa-2>
              <v-text-field
                v-model="updateForm.other_cost"
                :label="`${$t('Other Cost')} (${systemCurrency})`"
                hide-details
                box
                name="other_cost"
                background-color="white"
                :error="errors.has('other_cost')"
                v-validate="'decimal:3'"
                @input="calculateGrandTotalAmount()"
                data-vv-delay="1000"
              />
            </v-flex>

            <v-flex pa-2 v-if="settings.purchase_tax === 'Active'">
              <v-text-field
                v-model="updateForm.tax"
                :label="`${$t('Grand Total Tax')} (${systemCurrency})`"
                hide-details
                box
                readonly
                name="tax"
                background-color="white"
                :error="errors.has('tax')"
                v-validate="'decimal:3'"
                @input="calculateGrandTotalAmount()"
                data-vv-delay="1000"
              />
            </v-flex>

            <v-flex pa-2>
              <v-text-field
                v-model="updateForm.grand_total_amount"
                :label="`${$t('Grand Total Amount')} (${systemCurrency}) *`"
                hide-details
                box
                readonly
                name="grand_total_amount"
                background-color="white"
                :error="errors.has('grand_total_amount')"
                v-validate="'required|decimal:3'"
                data-vv-delay="1000"
              />
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :disabled="rowNumbers < 1" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnUpdateLoading: false,
      updateForm: {
        attachment: null,
        bill_date: '',
        total_amount: 0,
        transport_cost: 0,
        other_cost: 0,
        tax: 0,
        grand_total_amount: 0,
        cash_or_opening_balance: '',
        product_id_fk: [],
        collection_id_fk: [],
        purchase_quantity: [],
        purchase_price: [],
        purchase_tax: [],
        total_tax: [0],
        total: [0],
        expire_date: ['']
      },
      collections: [],
      billDateMenu: false,
      expireDateMenu: [false],
      rowNumbers: 1,
      fileSelected: false,
      fileName: '',
      fileData: null,
      fileInput: null,
      theFile: null
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      purchaseInfo: 'purchases/getPurchaseInfo',
      purchaseProductsList: 'products/getFullPurchaseProductsList',
      supplierList: 'suppliers/getFullVendersList',
      paymentTypes: 'purchases/getPaymentTypes',
      settings: 'configurations/getSystemSettings'
    }),
    hasExpiry() {
      return this.settings.product_expiry === 'Active'
    },
    hasTax() {
      return this.settings.purchase_tax === 'Active'
    },
    hasCollection() {
      return this.settings.production_collections === 'Active'
    },
    hasOpeningBalance() {
      return this.settings.opening_balance_status === 'Active'
    },
    twoOfThem() {
      return (
        (this.hasExpiry ? this.hasTax || this.hasCollection : this.hasTax && this.hasCollection) && !this.bothOfThem
      )
    },
    bothOfThem() {
      return this.hasExpiry && this.hasTax && this.hasCollection
    }
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          if (this.hasOpeningBalance) {
            this.paymentTypes.push({ value: 'Opening Balance', text: this.$t('Opening Balance') })
          }
          this.removeFile()
          this.rowNumbers = this.purchaseInfo.data_detail.length
          this.updateForm.attachment = this.purchaseInfo.data.attachment
          this.updateForm.supplier_invoice_number = this.purchaseInfo.data.supplier_invoice_number
          this.updateForm.vender_id_fk = this.purchaseInfo.data.vender_id_fk
          this.updateForm.bill_date = this.purchaseInfo.data.bill_date
          this.updateForm.total_amount = this.purchaseInfo.data.total_amount
          this.updateForm.cash_or_opening_balance = this.purchaseInfo.data.cash_or_opening_balance
          this.updateForm.attachment = this.purchaseInfo.data.attachment
          this.updateForm.purchase_id = this.purchaseInfo.data.purchase_id
          this.updateForm.transport_cost = this.purchaseInfo.data.transfer_cost
          this.updateForm.other_cost = this.purchaseInfo.data.other_cost
          this.updateForm.tax = this.purchaseInfo.data.tax
          this.updateForm.grand_total_amount = this.purchaseInfo.data.grand_total_amount

          this.updateForm.product_id_fk = []
          this.updateForm.collection_id_fk = []
          this.updateForm.purchase_quantity = []
          this.updateForm.purchase_price = []
          this.updateForm.expire_date = []
          this.updateForm.total = []
          this.updateForm.purchase_tax = []
          this.updateForm.purchase_tax_tax = []
          this.updateForm.total_tax = []

          this.purchaseInfo.data_detail.forEach((item, index) => {
            this.updateForm.product_id_fk.push(item.product_id_fk)
            this.updateForm.collection_id_fk.push(item.collection_id_fk)
            if (item.collection_id_fk !== null) {
              this.findCollections(index)
              this.updateForm.purchase_quantity.push(item.purchase_collection_quantity)
              this.updateForm.purchase_price.push(item.purchase_collection_price)
              this.updateForm.purchase_tax.push(item.purchase_collection_tax)
              this.updateForm.total.push(item.total_collection)
              this.updateForm.total_tax.push(item.total_collection_tax)
            } else {
              this.updateForm.purchase_quantity.push(item.purchase_quantity)
              this.updateForm.purchase_price.push(item.purchase_price)
              this.updateForm.purchase_tax.push(item.purchase_tax)
              this.updateForm.total.push(item.total)
              this.updateForm.total_tax.push(item.total_tax)
            }
            this.updateForm.expire_date.push(item.expire_date)
            this.expireDateMenu.push(false)
          })

          if (this.updateForm.attachment) {
            this.fileSelected = true
          }

          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updatePurchaseInfo: 'purchases/updatePurchaseInfo'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    chooseFile() {
      this.$refs.fileInput.click()
    },

    onSelectFile() {
      this.fileInput = this.$refs.fileInput
      this.theFile = this.fileInput.files

      if (this.theFile && this.theFile[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.fileData = e.target.result
        }
        reader.readAsDataURL(this.theFile[0])
        this.$emit('input', this.theFile[0])
        this.fileName = this.theFile[0].name
        this.fileSelected = true
      }
    },

    removeFile() {
      this.fileData = null
      this.fileInput = null
      this.theFile = null
      this.$refs.fileInput.value = null
      this.updateForm.attachment = null
      this.fileName = ''
      this.fileSelected = false
    },

    addRow() {
      this.updateForm.expire_date[this.rowNumbers] = ''
      this.expireDateMenu[this.rowNumbers] = false
      this.updateForm.total[this.rowNumbers] = 0
      this.updateForm.purchase_tax[this.rowNumbers] = 0
      this.rowNumbers++
    },

    removeRow(index) {
      this.rowNumbers--
      this.updateForm.product_id_fk.splice(index, 1)
      this.updateForm.purchase_quantity.splice(index, 1)
      this.updateForm.purchase_price.splice(index, 1)
      this.updateForm.expire_date.splice(index, 1)
      this.expireDateMenu.splice(index, 1)
      this.updateForm.total.splice(index, 1)
      this.updateForm.purchase_tax.splice(index, 1)
      this.calculateTotalTaxAmount()
      this.calculateTotalAmount()
    },

    findCollections(index) {
      const filteredProduct = this.purchaseProductsList.filter(
        item => item.value === this.updateForm.product_id_fk[index]
      )[0]
      this.collections[index] = filteredProduct.collections
    },

    findCollection(index) {
      return this.collections[index].filter(item => item.collection_id === this.updateForm.collection_id_fk[index])[0]
    },

    collectionQuantity(index) {
      return this.findCollection(index).collection_quantity
    },

    calculateTotal(index) {
      const quantity = this.updateForm.purchase_quantity[index] || 0
      const price = this.updateForm.purchase_price[index] || 0
      this.updateForm.total[index] = Number((quantity * price).toFixed(2))
      this.calculateTotalAmount()
    },

    calculateTotalAmount() {
      this.updateForm.total_amount = this.updateForm.total.reduce((a, b) => a + b, 0).toFixed(2)
      this.calculateGrandTotalAmount()
    },

    calculateGrandTotalAmount() {
      this.updateForm.grand_total_amount = (
        Number(this.updateForm.total_amount) +
        Number(this.updateForm.transport_cost) +
        Number(this.updateForm.other_cost) +
        Number(this.updateForm.tax)
      ).toFixed(2)
    },

    calculateTotalTax(index) {
      const quantity = this.updateForm.purchase_quantity[index] || 0
      const tax = this.updateForm.purchase_tax[index] || 0
      this.updateForm.total_tax[index] = Number((quantity * tax).toFixed(2))
      this.calculateTotalTaxAmount()
    },

    calculateTotalTaxAmount() {
      this.updateForm.tax = this.updateForm.total_tax.reduce((a, b) => a + b, 0).toFixed(2)
      this.calculateGrandTotalAmount()
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true
          let formData = new FormData(event.target)
          formData.append('vender_id_fk', this.updateForm.vender_id_fk)
          formData.append('cash_or_opening_balance', this.updateForm.cash_or_opening_balance)

          if (this.theFile === null && this.updateForm.attachment === null) {
            formData.append('attachment', '')
          } else if (this.theFile !== null) {
            formData.append('attachment', this.theFile[0])
          }

          this.updateForm.product_id_fk.forEach((product, index) => {
            formData.append('product_id_fk[' + index + ']', product)
            formData.append('collection_id_fk[' + index + ']', this.updateForm.collection_id_fk[index] || '')
            if (this.updateForm.collection_id_fk[index]) {
              formData.append('purchase_collection_quantity[' + index + ']', this.updateForm.purchase_quantity[index])
              formData.append('purchase_collection_price[' + index + ']', this.updateForm.purchase_price[index])
              formData.append(
                'purchase_quantity[' + index + ']',
                (this.updateForm.purchase_quantity[index] * this.collectionQuantity(index)).toFixed(2)
              )
              formData.append(
                'purchase_price[' + index + ']',
                (this.updateForm.purchase_price[index] / this.collectionQuantity(index)).toFixed(2)
              )
              formData.append('purchase_collection_tax[' + index + ']', this.updateForm.purchase_tax[index])
              formData.append(
                'purchase_tax[' + index + ']',
                (this.updateForm.purchase_tax[index] / this.collectionQuantity(index)).toFixed(2)
              )
            } else {
              formData.append('purchase_collection_quantity[' + index + ']', '')
              formData.append('purchase_collection_price[' + index + ']', '')
              formData.append('purchase_quantity[' + index + ']', this.updateForm.purchase_quantity[index])
              formData.append('purchase_price[' + index + ']', this.updateForm.purchase_price[index])
              formData.append('purchase_collection_tax[' + index + ']', '')
              formData.append('purchase_tax[' + index + ']', this.updateForm.purchase_tax[index])
            }
            formData.append('expire_date[' + index + ']', this.updateForm.expire_date[index] || '')
            formData.append('total[' + index + ']', this.updateForm.total[index])
            formData.append('total_tax[' + index + ']', this.updateForm.total_tax[index])
          })

          let payload = { id: this.updateForm.purchase_id, formData }
          this.updatePurchaseInfo(payload)
            .then(() => {
              this.btnUpdateLoading = false
              this.$emit('updated')
            })
            .catch(() => {
              this.btnUpdateLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
